import { observer } from 'mobx-react';

import { useMonetizationWidgetData } from '../../hooks';
import type { MonetizationWidgetDataType, WidgetSizeType } from '../../types';
import { GeneralSmallWidget, GeneralWideWidget } from '../GeneralWidget';
import { WidgetWrapper } from '../WidgetWrapper/WidgetWrapper';

import { MonetizationWidgetTimer } from './MonetizationWidgetTimer/MonetizationWidgetTimer';

interface MonetizationWidgetProps {
  sizeType: WidgetSizeType;
  data: MonetizationWidgetDataType;
}

function MonetizationWidgetComponent(props: MonetizationWidgetProps) {
  const { data, sizeType } = props;
  const { event } = data;

  const { widgetImageUrl, handleClick, timerDate, onTimeEnd } = useMonetizationWidgetData({ event });

  const hideWidgetTimer = !timerDate;

  const timer = hideWidgetTimer ? null : (
    <MonetizationWidgetTimer endDate={timerDate} extended={sizeType === 'wide'} onEnd={onTimeEnd} />
  );
  const smallWidgetExtended = !!timer;

  return (
    <WidgetWrapper
      dataTestId="monetization-widget"
      sizeType={sizeType}
      smallWidgetExtended={smallWidgetExtended}
      onClick={handleClick}
    >
      {sizeType === 'small' ? (
        <GeneralSmallWidget timer={timer} widgetImageUrl={widgetImageUrl} />
      ) : (
        <GeneralWideWidget timer={timer} widgetImageUrl={widgetImageUrl} />
      )}
    </WidgetWrapper>
  );
}

export const MonetizationWidget = observer(MonetizationWidgetComponent);
